import React, { useContext } from 'react';

import { LocationContext } from '../../contexts/LocationContext';
import { SingleEntry } from '../../graphql-fragments/navigationMenu';
import { getUrlFromVersatileLink } from '../../utils/sanity';
import { checkUrlsMatch, clsx } from '../../utils/utils';
import * as styles from './MenuEntry.module.scss';
import SmartLink from './SmartLink';

export interface MenuEntryProps {
  entry: SingleEntry;
  withMorePaddingLeft?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  noLocalize?: boolean;
  isActive?: boolean;
}

const MenuEntry = ({
  entry,
  withMorePaddingLeft,
  className,
  onClick,
  noLocalize,
  isActive,
}: MenuEntryProps): React.ReactElement => {
  const location = useContext(LocationContext);

  return (
    <SmartLink
      onClick={onClick}
      to={getUrlFromVersatileLink(entry)}
      className={clsx(
        styles.link,
        (isActive ||
          (location && checkUrlsMatch(location.pathname, getUrlFromVersatileLink(entry)))) &&
          styles.active,
        withMorePaddingLeft && styles.morePaddingLeft,
        className,
      )}
      noLocalize={noLocalize}
    >
      {entry.title}
    </SmartLink>
  );
};

export default MenuEntry;
